import { Api } from 'models/services/api';
import { CreateIngredientCategoryQuery } from 'models/services/graphql';

import { IngredientCategoryData, IngredientCategoryDataToCreate } from '../index';

type DataToCreate = {
  businessId: string;
  input: IngredientCategoryDataToCreate;
};

const RequestQuery = `
  mutation CreateIngredientCategory($businessId: ID!, $input: IngredientCategoryCreateInput!) {
    ${CreateIngredientCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createIngredientCategory: IngredientCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: IngredientCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createIngredientCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };